import React from 'react';
import { TypographyComponent as TypographyElement } from '@tvg/fuse-design';
import styled from 'styled-components';

const SimpleLink = styled.a`
  text-decoration: none;
  color: var(--color-global-blue700) !important;
`;

interface Props {
  offerTerms2?: string;
  offerTerms3?: string;
}

function InsuranceVoucherPage(props: Props) {
  const { offerTerms2, offerTerms3 } = props;

  return (
    <>
      {offerTerms2 && (
        <TypographyElement type="paragraph" size="1" tag="p" data-testid="insurance-voucher-dialog-offer-terms-2">
          {offerTerms2}
          <br />
        </TypographyElement>
      )}

      {offerTerms3 && (
        <TypographyElement type="paragraph" size="1" tag="p" data-testid="insurance-voucher-dialog-offer-terms-3">
          {offerTerms3}
          <br />
        </TypographyElement>
      )}

      <TypographyElement type="paragraph" size="1" tag="p" data-testid="insurance-voucher-dialog-text-with-hyperlink">
        {'You can cancel your policy in your online account or '}
        <SimpleLink
          href="/financial-services-contact-numbers.page"
          target="_blank"
          data-testid="insurance-call-us-link"
          rel="noreferrer"
        >
          call us
        </SimpleLink>
        .
      </TypographyElement>
    </>
  );
}

export default InsuranceVoucherPage;
